import React from 'react';
import { WxbIcon } from '../Icon/Icon';
import type { WxbIconName } from '../Icon/icons';
import './ValidationList.css';

export type WxbValidationLevel = 'success' | 'info' | 'warning' | 'error';

export interface WxbValidationItem {
  key: string;
  level?: WxbValidationLevel;
  title: React.ReactNode;
  description?: React.ReactNode;
  source?: React.ReactNode;
  action?: React.ReactNode;
}

export interface WxbValidationListProps extends React.HTMLAttributes<HTMLDivElement> {
  items: WxbValidationItem[];
  emptyText?: React.ReactNode;
  density?: 'comfortable' | 'compact';
}

const ICON_BY_LEVEL: Record<WxbValidationLevel, WxbIconName> = {
  success: 'released',
  info: 'inspect',
  warning: 'deviation',
  error: 'rejected',
};

const joinClasses = (...classes: Array<string | false | undefined>) =>
  classes.filter(Boolean).join(' ');

export const WxbValidationList: React.FC<WxbValidationListProps> = ({
  items,
  emptyText = '暂无校验问题',
  density = 'comfortable',
  className = '',
  ...props
}) => (
  <div className={joinClasses('wxb-validation-list', `wxb-validation-list-${density}`, className)} {...props}>
    {items.length === 0 ? (
      <div className="wxb-validation-empty">{emptyText}</div>
    ) : items.map((item) => {
      const level = item.level ?? 'info';
      return (
        <div className={joinClasses('wxb-validation-item', `wxb-validation-item-${level}`)} key={item.key}>
          <span className="wxb-validation-icon" aria-hidden="true">
            <WxbIcon name={ICON_BY_LEVEL[level]} size={18} />
          </span>
          <span className="wxb-validation-copy">
            <span className="wxb-validation-title-row">
              <span className="wxb-validation-title">{item.title}</span>
              {item.source && <span className="wxb-validation-source">{item.source}</span>}
            </span>
            {item.description && <span className="wxb-validation-desc">{item.description}</span>}
          </span>
          {item.action && <span className="wxb-validation-action">{item.action}</span>}
        </div>
      );
    })}
  </div>
);

